import { safeFetch } from "../utils/safeFetch";

const BASE_URL = '/api/emails';

export async function inviaPreventivoEmail(payload, token, tenantId) {
  const res = await safeFetch(`${BASE_URL}/send-quote`, {
    method: 'POST',
    headers: {
      'Content-Type':  'application/json',
      'Authorization': `Bearer ${token}`,
      'x-tenant-id':   tenantId,
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    if (res.status === 0) {
      throw new Error("Impossibile connettersi al server");
    }
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Errore durante l'invio del preventivo.");
  }

  if (res.status === 204) return null;
  return res.json();
}
